import theme from './theme';
import type { ThemeColorName, ThemeSpacingName, ThemeBreakpointName } from './theme';
import { default as queryObj, mq } from './query';
import {} from './theme';
import { ThemeFontName } from './types';

// TODO: allow passing of theme for all these functions

export const color = (name: ThemeColorName) => () => theme.colors[name];

export const space = (name: ThemeSpacingName) => () => `${theme.spacing[name]}`;

export const font = (name: ThemeFontName) => () => {
  const font = theme.fonts[name];
  return { ...font };
};

export const fontStack = (names: ThemeFontName[]) => () => {
  const defs = names.map((name) => theme.fonts[name]);
  return mq({
    //TODO: write a helper to do this kind of pivot on stacks of rules
    fontFamily: defs.map((d) => d.fontFamily),
    fontStyle: defs.map((d) => d.fontStyle),
    fontWeight: defs.map((d) => d.fontWeight),
    fontSize: defs.map((d) => d.fontSize),
    lineHeight: defs.map((d) => d.lineHeight),
    letterSpacing: defs.map((d) => d.letterSpacing),
  });
};

const atLeast = (breakpoint: ThemeBreakpointName) => () => queryObj.atLeast[breakpoint];

const below = (breakpoint: ThemeBreakpointName) => () => queryObj.below[breakpoint];

export const query = {
  atLeast,
  below,
};
